import { __read } from "tslib";
import { groupBy, toPairs, maxBy } from 'lodash-es';
import sanitize from 'sanitize-filename';
import { getAssets, hasAssets, getLayerName } from './element';
var preferredAssetFormats = ['webp', 'png', 'jpg', 'svg', 'UNKNOWN'];
export function getBestAsset(groupedAssets, maxWidth) {
    for (var i = 0; i < preferredAssetFormats.length; i += 1) {
        var assets = groupedAssets[preferredAssetFormats[i]];
        if (assets) {
            var url = getBiggestAsset(assets).url;
            if (url && maxWidth) {
                url = downscaledAsset(url, maxWidth);
            }
            return url;
        }
    }
    return null;
}
export function downscaledAsset(url, maxWidth) {
    return url + "&width=" + maxWidth * (window.devicePixelRatio || 1);
}
function getBiggestAsset(assets) {
    return maxBy(assets, function (asset) { return asset.scale; });
}
export function getScreenAssets(screenName, elements) {
    var contents = elements.reduce(function (acc, element) {
        if (hasAssets(element)) {
            var elementAssets = getElementAssetsFolder(element);
            var folder = sanitize(getLayerName(element));
            folder = getUniqueNameForFolder(acc, folder);
            acc[folder] = {
                type: 'folder',
                contents: elementAssets,
            };
        }
        return acc;
    }, {});
    return getZIP(screenName, contents);
}
export function getElementAssets(element) {
    var zipName = "" + sanitize(getLayerName(element));
    var contents = getElementAssetsFolder(element);
    return getZIP(zipName, contents);
}
export function getElementAssetsOfType(element, assetType) {
    var assets = groupBy(getAssets(element), 'format')[assetType];
    var layerName = getLayerName(element);
    var zipName = sanitize(layerName) + "_" + assetType;
    var assetContents = getAssetTypeFolder(layerName, assets, assetType);
    return getZIP(zipName, assetContents);
}
function getElementAssetsFolder(element) {
    var elementAssets = toPairs(groupBy(getAssets(element), 'format'));
    var layerName = getLayerName(element);
    var folder = elementAssets.reduce(function (acc, _a) {
        var _b = __read(_a, 2), assetType = _b[0], assets = _b[1];
        var contents = getAssetTypeFolder(layerName, assets, assetType);
        acc[assetType === 'UNKNOWN' ? 'assets' : assetType] = {
            type: 'folder',
            contents: contents,
        };
        return acc;
    }, {});
    return folder;
}
function getAssetTypeFolder(layerName, assets, assetType) {
    return assets.reduce(function (rootPath, asset) {
        var assetPath = createNestedDirectoriesAndGetAssetPath(rootPath, asset.prefix);
        var prefix = (asset.prefix || '').split('/').pop();
        var name = sanitize("" + prefix + layerName + asset.suffix + (assetType === 'UNKNOWN' ? '' : "." + assetType));
        name = getUniqueNameForFile(assetPath, name);
        assetPath[name] = {
            type: 'file',
            url: asset.url,
        };
        return rootPath;
    }, {});
}
// In Sketch "prefix" can contain path separators.
// When it does, the following function generates a directory tree, so that
// the asset will be included in the right subdirectory.
// Examples:
// - "dirA/dirB/": dirA -> dirB -> filename
// - "prefixA": prefixAfilename
// - "dirA/prefixB": dirA -> prefixBfileName
function createNestedDirectoriesAndGetAssetPath(rootPath, prefix) {
    if ((prefix || '').indexOf('/') === -1) {
        return rootPath;
    }
    var assetPath = rootPath;
    (prefix || '')
        .split('/')
        .filter(function (dir) { return dir.length !== 0; })
        .forEach(function (currentDir) {
        if (!assetPath[currentDir]) {
            assetPath[currentDir] = {
                type: 'folder',
                contents: {},
            };
        }
        assetPath = assetPath[currentDir];
    });
    return assetPath.type === 'folder' ? assetPath.contents : assetPath;
}
function getZIP(filename, contents) {
    return {
        name: sanitize(filename),
        contents: contents,
    };
}
function getUniqueNameForFolder(map, name) {
    if (!(name in map)) {
        return name;
    }
    var suffix = 1;
    while (name + "_" + suffix in map) {
        suffix += 1;
    }
    return name + "_" + suffix;
}
function getUniqueNameForFile(map, filename) {
    if (!(filename in map)) {
        return filename;
    }
    var suffix = 0;
    var newFileName;
    do {
        suffix += 1;
        var _a = getFileNameAndExtension(filename), name_1 = _a.name, extension = _a.extension;
        newFileName = name_1 + "_" + suffix + "." + extension;
    } while (newFileName in map);
    return newFileName;
}
function getFileNameAndExtension(filename) {
    var parts = filename.split('.');
    var extension = parts.pop();
    var name = parts.join('.');
    return { name: name, extension: extension };
}
